/**
 * Created by jehe on 17.04.2020.
 */

/*global define, require, $, ol, proj4, window*/

/*jslint browser: true*/

import Style from 'ol/style/Style.js';
import Stroke from 'ol/style/Stroke.js';
import Fill from 'ol/style/Fill.js';
import Vector from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Icon from 'ol/style/Icon.js';
import WFS from 'ol/format/WFS.js';

import global from "./js/globals";
import creator from "./js/elementCreator";

"use strict";
var config, format;
var privateFns = {
	addFeatureInfoTopDiv: function () {
		var div = creator.createDiv({css: "top-div"});
		div.appendChild(creator.createButton({
			css: "close-me-featureinfo",
			ariaLabel: "lukk kontekstmeny",
			icon: true,
			iconClass: "icon-Close",
			onclick: function () {
				$(".featureinfo").removeClass("aside-show");
				$(".featureinfo-tip").removeClass("featureinfo-tip-hide");
				global.clearMap("keepHighlight");
				setTimeout(function() {
					$(".featureinfo").hide();
				}, 500);
			}
		}));
		div.appendChild(creator.createButton({
			css: "minimize-me",
			ariaLabel: "minimer kontekstmeny",
			id: "contextMinimize",
			icon: true,
			iconClass: "fa fa-window-minimize",
			onclick: function (e) {
				$($("#contextMinimize")[0].parentElement.parentElement).toggleClass("featureinfo-minimized");
				$("#contextMinimize").find("i").toggleClass("fa-window-minimize").toggleClass("fa-window-maximize");
			}
		}));
		return div;
	},
	addEiendomFeatureInfo: function (bottom, fields) {
		var section = creator.createSection({
			css: "featureinfo-wrapper feature-info-eiendom"
		});
		section.appendChild(creator.createDiv({
			id: "eiendom-info-ct",
			css: "feature-info-ct"
		}));
		fields.forEach(function (field) {
			if(!field.fields){					
				section.appendChild(privateFns.addFeatureInfoField("", field));
			}else{
				var parentField = privateFns.addFeatureInfoHeader("", field);
				field.fields.forEach(function(subFields){
					//parentField.appendChild(privateFns.addFeatureInfoField("", subFields));
				});
				section.appendChild(parentField);
			}
		});
		if (bottom) {
			section.appendChild(privateFns.addDyplenkeField(bottom));
		}
		return section;
	},
	addFeatureInfoHeader: function (idPrefix, field) {
		var wrapper = creator.createDiv({
			css: "feature-info-ct",
			id: idPrefix + field.id + "-info-ct"
		});
		wrapper.style.marginBottom = "10px";
		var heading = document.createElement("button");
		heading.type = "button";
		heading.className = "info-heading-header navtogglerActive";
		heading.appendChild(creator.createH3({
			text: field.title
		}));
		heading.appendChild(creator.createIcon({
			css: "icon-Close context-icon-style"
		}));
		if (field.featureCount) {
			heading.appendChild(creator.createSpan({
				css: "feature-count",
				text: 0
			}));
		}
		
		$(heading).click(function (e) {
			$(e.currentTarget).parent().children(".feature-info-ct").toggle(300, function(){});
			$(".feature-info-ct").each(function (idx, el) {
				if(el.parentElement != heading && $(el).hasClass("icon-Close")){
					$(el).toggleClass("glyphicon glyphicon-option-vertical").toggleClass("icon-Close");
				}
			});
			$(heading).toggleClass("navtogglerStyler").toggleClass("navtogglerActive");
			$(heading).find("i").toggleClass("glyphicon glyphicon-option-vertical").toggleClass("icon-Close");
		});
		wrapper.appendChild(heading);
		if (field.subTitle) {
			wrapper.appendChild(creator.createSpan({
				css: "contextSubHeader",
				text: field.subTitle
			}));
		}
		return wrapper;
	},
	createContextMenu: function(mapDiv){
		var div, wrapper, closeDiv, closeBtn, closeIcon, eiendom;
		div = creator.createDiv({css: 'feature-info-page', id: 'feature-info-page'});
		
		wrapper = creator.createDiv({css: 'feature-info-wrapper'});
		
		closeDiv = creator.createDiv({css: 'feature-info-close-div'});
		closeBtn = creator.createButton({css: "close"});
		closeBtn.onclick = function () {
			var target = $("#feature-info-page");
			if ($(window).width <= 500) {
				target.animate({right: '-100%'}, 430);
			} else {
				target.animate({right: '-430px'}, 430);
			}
		};
		closeIcon = creator.createIcon({css: 'glyphicon glyphicon-remove'});
		closeBtn.appendChild(closeIcon);
		closeDiv.appendChild(closeBtn);
		div.appendChild(closeDiv);
		
		eiendom = document.createElement('div');
		eiendom.className = 'feature-info-ct';
		eiendom.id = 'eiendom-info-ct';
		wrapper.appendChild(eiendom);
		
		wrapper.appendChild(privateFns.createContextTakoverflate());
		
		div.appendChild(wrapper);
		mapDiv.appendChild(div);
	},

	createContextTakoverflate: function(){
		var wrapper, heading, headingBtn, container;
		wrapper = creator.createDiv({css: 'feature-info-ct', id: 'takoverflate'});
		
		container = creator.createDiv({css: 'feature-info', id: 'overflate'});
		
		heading = creator.createDiv({css: 'feature-info-heading'});
		headingBtn = creator.createButton({
			css: 'btn btn-invisible info-heading',
			text: "Solinnstråling på takflaten ",
			title: "Årlig innstråling"
		});
		var a = creator.createA({title: "Årlig innstråling"});
		a.setAttribute("data-content", "Årlig innstråling (kWh/m2 beregnet ut fra en digital overflatemodell laget fra laserdata. Beregningen inkluderer skyggeeffekter fra bygninger, vegetasjon og terreng. Resultatet er kalibrert mot måleresultater fra met.no.");
		a.setAttribute("data-placement", "bottom");
		a.setAttribute("data-toggle", "popover");
		a.setAttribute("data-container", "body");
		var img = creator.createImage({src: "http://shots.jotform.com/kade/Screenshots/blue_question_mark.png"});
		img.style.height = "13px";
		a.appendChild(img);
		headingBtn.appendChild(a);
		headingBtn.onclick = function(){
			$('#overflate').toggle();
		};
		heading.appendChild(headingBtn);
		wrapper.appendChild(heading);
		wrapper.appendChild(container);
		var downloadCSV = creator.createButton({text: "Last ned data", css: "downloadBtn"});
		downloadCSV.onclick = function(){
			privateFns.createCsv();
		}
		wrapper.appendChild(downloadCSV);
		return wrapper;
	},
	createCsv: function(){
		var arrData = privateFns.createCsvArray();
		var CSV = ''; 
		var header = '';
		for (var index in arrData[0]) {
			header += index + ';';
		}
		header.slice(0, header.length - 1);
		CSV += header + '\r\n';
		for (var i = 0; i < arrData.length; i++) {
			var row = "";
			for (var index in arrData[i]) {
				row += arrData[i][index] + ';';
			}
			row.slice(0, row.length - 1);
			CSV += row + '\r\n';
		}

		if (CSV == '') {        
			alert("Invalid data");
			return;
		}
		var fileName = "solkartData";
		var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
		var link = creator.createA({});
		link.href = uri;
		link.style = "visibility:hidden";
		link.download = fileName + ".csv";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	},
	createCsvArray: function(){
		let csvArray = []; 
		let flater = global.selectFeatures;
		flater.forEach(function(flate){
			let current = {};
			current.id = flate.get("TAK_ID");
			current["Årlig instråling (kWh/m²)"] = flate.get("SUM_AAR_KWH");
			current["areal m²"] = flate.get("AREA");
			for(let i = 1; i <= 52; i++){
				let week = "week" + i + " Wh/m²";
				current[week] = flate.get("UKE"+i);
			}
			csvArray.push(current);
		});
		return csvArray;
	},
	
	initContextMenuInteraction: function (conf) {
		global.mapclick = true;
		global.map.on("click", function (e) {
			if(global.mapclick){
				privateFns.contextMenuInteractionHandler(e);				
			}
		})
	},
	contextMenuInteractionHandler: function (e) {
		var abort = false;
		var coords;
		if(Array.isArray(e)){
			coords = e;
		}else{
			coords = e.coordinate;
		}
		// Fjerner eventuelle popups
		global.map.getOverlays().getArray()[0].setPosition(undefined);
		if (global.clickInfoInProgress === false) {
			global.clickInfoInProgress = true;

			// Fjerner eventuell tekst i søkefeltet
			$("#large-search").val("");

			privateFns.searchMap(coords);
			if (abort === false) {
				var clickFeature = new Feature({
					name: "clickFeature",
					geometry: new Point(coords)
				});
				clickFeature.setStyle(new Style({
					image: new Icon({
						anchor: [0.5, 1],
						size: [32, 32],
						src: worldPath + '/icons/Kart PinBlue.png',
					}),
				}));
				var markerlayer = global.map.getLayerById("fontmarkers");
				markerlayer.getSource().clear();
				markerlayer.getSource().addFeature(clickFeature);
		
			} else {
				global.clickInfoInProgress = false;
			}
		}
	},
	searchMap: function(coords){
		var url;
		url = "https://od2.pbe.oslo.kommune.no/cgi-bin/mapserv.exe?map=d:/data_mapserver/kartfiler/solkart.map&SERVICE=WFS&VERSION=1.1.0&REQUEST=GetFeature&TYPENAME=takflater2024&bbox=";
		url +=  (coords[0] - 0.1) + "," + (coords[1] - 0.1) + "," + (coords[0] + 0.1) + "," + (coords[1] + 0.1);
		$.ajax({
			url: url,
			success: function (response) {
				var features, feature, clickFeature;
				format = new WFS({
					featureNS: "http://mapserver.gis.umn.edu/mapserver",
					featureType: "takflater2024"
				});
				features = format.readFeatures(response);
				if (features.length > 0) {
					// Dersom wfs returnerer flere objekter bruker vi bare det første
					feature = features[0];
					
					clickFeature = new Feature({
						name: 'clickFeature',
						geometry: new Point(coords)
					});
					var byggnr = feature.get('BYGGNR');
					if(byggnr > 0){
						var markerlayer = global.map.getLayerById("fontmarkers");
						markerlayer.getSource().addFeature(clickFeature);
						markerlayer.getSource().addFeature(feature);
						privateFns.getBuilding(byggnr, features);
						//openlayersFns.getEiendomForCoordinate(coords);
						privateFns.handleMapClick(coords,"", config);
					} else {
						console.log("traff ingen bygg");
						global.clickInfoInProgress = false;
					}
				} else {
					console.log("traff ingen bygg");
					global.clickInfoInProgress = false;
				}
			},
			error: function (response) {
				console.error(response);
			}
		});
	},
	getBuilding: function(byggnr, clickedFeatures){
		var featureInfoPage;
		var url2 = "https://od2.pbe.oslo.kommune.no/cgi-bin/mapserv.exe?map=d:/data_mapserver/kartfiler/solkart.map&SERVICE=WFS&VERSION=1.1.0&REQUEST=GetFeature&TYPENAME=takflater2024";
		url2 += "&Filter=<Filter><PropertyIsEqualTo><PropertyName>BYGGNR</PropertyName><Literal>"+ byggnr +"</Literal></PropertyIsEqualTo></Filter>";
		featureInfoPage = $("#feature-info-page");
		$.ajax({
			url: url2,
			success: function (response){
				var features, feature, table;
				global.flater = [];
				document.getElementById("overflate").appendChild(privateFns.createTable());
				var table = document.getElementById("table");
				format = new WFS({
					featureNS: "http://mapserver.gis.umn.edu/mapserver",
					featureType: "takflater2024"
				});
				features = format.readFeatures(response);
				for(var j = 0; j < features.length; j++){
					var highlightLayer = global.map.getLayerById("highlighter");
					highlightLayer.getSource().addFeatures([features[j]]);
				}
				if(features.length > 0) {
					global.selectFeatures = features;
					for(var i = 0; i < features.length; i++){
						var areal = 0 , sol = 0;
						var flate = {id: "", selected: "", verdi: "", areal: ""};
						feature = features[i];
								
						sol = parseInt(feature.get("SUM_AAR_KWH"));
						areal = parseFloat(feature.get('AREA').replace(/^,+/,'0,'));
						global.sol = sol;
						global.areal = areal;
						flate.verdi = sol;
						flate.areal = areal;
						
						flate.id = "Flate" + (i+1);
						flate.selected = true;
						global.flater.push(flate);
					}
					
					if(featureInfoPage.is(":visible") === false){
						featureInfoPage.show();
					}
					if(featureInfoPage.css('right') !== '0px'){
						featureInfoPage.animate({right: '0'}, 500);
						$('#extended-feature-info-page').animate({right:'-500px'});
					}
					privateFns.update(features);
				}else{
					console.log("traff ingen bygg");
				}
				global.clicked = true;
			},
			error: function (response) {
				console.error(response);
			}
		});
	},
	update: function(flater){
		let table = document.getElementById("table");
		for(var i = 0; i < flater.length; i++){
			let row = document.createElement("tr");
			let flate = flater[i];
			
			row.appendChild(privateFns.createColumn(parseFloat(flate.get("AREA")).toFixed(0),"areal"));
			row.appendChild(privateFns.createColumn(parseInt(flate.get("SUM_AAR_KWH")),"verdi"));
			row.appendChild(privateFns.createColumn(flate.get("TAK_ID"), "id"));
			
			$(row).hover(privateFns.onTableRowHover([flater[i]]));
			table.appendChild(row);
		}
	},
	onTableRowHover: function (collection) {
		var layer = global.map.getLayerById("hoverHighlightLayer");
		layer.setZIndex(2);
		return function (e) {
			var hoverClass = "highlight-feature";
			if (e.type === "mouseenter") {
				e.target.parentNode.classList.add("hoverClass");
				collection.forEach(function (feature) {
					layer.getSource().addFeature(feature);
				});
				$(e.currentTarget).addClass(hoverClass);
			} else {
				e.target.parentNode.classList.remove("hoverClass");
				layer.getSource().clear();
				$(e.currentTarget).removeClass(hoverClass);
			}
		};
	},
	handleMapClick: function (coord, origin, config) {
		var showContext = true;
		// Tømmer alle tidligere verdier fra kontekstmeny
		privateFns.clearContextMenu();
		$("#search-result-page").remove();
		var featureInfoPage = $(".featureinfo");
		if (featureInfoPage.is(":visible") === false) {
			featureInfoPage.show();
		}
		if (featureInfoPage.hasClass("featureinfo-minimized")) {
			featureInfoPage.removeClass("featureinfo-minimized");
			featureInfoPage.find(".minimize-me").find("i").addClass("fa-window-minimize").removeClass("fa-window-maximize");
		}
		featureInfoPage.addClass("aside-show");
		$(".featureinfo-tip").addClass("featureinfo-tip-hide");
		if (showContext === false) {
			featureInfoPage.addClass("featureinfo-minimized");
			featureInfoPage.find(".minimize-me").find("i").removeClass("fa-window-minimize").addClass("fa-window-maximize");
		}
		if (global.appConfig.contextMenu.minimize){
			$($("#contextMinimize")[0].parentElement.parentElement).toggleClass("featureinfo-minimized");
			$("#contextMinimize").find("i").toggleClass("fa-window-minimize").toggleClass("fa-window-maximize");
		}
		privateFns.getEiendomForCoordinate(coord, config);
	},
	clearContextMenu: function () {
		var targets = $(".featureinfo-wrapper");
		targets.find("article").empty();
		targets.find(".feature-count").html("0");
		// Legger til disabled-klasse og legger til loader
		targets.find(".info-heading").addClass("info-disabled").append(privateFns.addLoader());						
		if($("#table")[0]){		
			var takoverflate = document.getElementById("takoverflate");
			takoverflate.parentNode.removeChild(takoverflate);
		}
		global.map.getLayerById("highlighter").getSource().clear();
	},
	getEiendomForCoordinate: function (coords, config) {
		var east = parseInt(coords[0], 10);
		var north = parseInt(coords[1], 10);
		$.ajax({
			url: global.phpAutocomplete + "kontekstmeny.php?e=" + east + "&n=" + north,
			/**
			* @param r {string}
			* @param r.teigid
			*/
			success: function (r) {
				var eiendomsInfo = JSON.parse(r)[0];
				if (eiendomsInfo) {
					//Markerer eiendom i kartet
					privateFns.getEiendomPolygon(eiendomsInfo, config.contextMenu);
					//Fyller inn eiendomsinfo i kontekstmenyen
					privateFns.renderEiendomsInfo(eiendomsInfo, global.intranett);

					$('.featureinfo-wrapper').append(privateFns.createContextTakoverflate());
				} else {
					$(".featureinfo").hide();
				}

				global.clickInfoInProgress = false;
			},
			fail: function () {
				global.clickInfoInProgress = false;
				console.error("fail");
			},
			error: function () {
				global.clickInfoInProgress = false;
				console.error("error");
			}
		});
	},
	addLoader: function () {
		var loader = creator.createDiv({css: "context-menu-loader"});
		var icon = creator.createIcon({css: "fa fa-spinner fa-pulse"});
		loader.appendChild(icon);
		return loader;
	},
	getEiendomPolygon: function (eiendomsInfo, contextConfig) {
		global.map.getLayerById("markers").getSource().clear();
		$("body").css("cursor", "wait");
		$.ajax({
			url: global.searchUrl + "&VERSION=1.1.0&SERVICE=WFS&REQUEST=GetFeature&TYPENAME=EIENDOM_WFS&Filter=<Filter><PropertyIsEqualTo><PropertyName>ID</PropertyName><Literal>" + eiendomsInfo.teigid + "</Literal></PropertyIsEqualTo></Filter>",
			success: function (response) {
				var format = privateFns.newWfsFormat("EIENDOM_WFS");
				var features = privateFns.readWfsFeatures(format, response);
				global.gnr = features[0].values_.GARDSNR;
				global.bnr = features[0].values_.BRUKSNR;
				global.bbox = features[0].values_.boundedBy;
				$("#doklink").remove();
				//global.addFeaturesToOverlay(features, "markers");
				$("body").css("cursor", "default");

				// Legger til eventuelle dyplenker
				if (contextConfig.mode.bottom) {
					$("#dyplenke-bottom-ct").empty();
					contextConfig.dyplenker.forEach(function (lenke) {
						var currentUrl = lenke.url;
						if (currentUrl.indexOf("@(gnr)") >= 0) {
							currentUrl = currentUrl.replace("@(gnr)", eiendomsInfo.gnr);
						}
						if (currentUrl.indexOf("@(bnr)") >= 0) {
							currentUrl = currentUrl.replace("@(bnr)", eiendomsInfo.bnr);
						}
						if (currentUrl.indexOf("@(polygon)") >= 0) {
							currentUrl = currentUrl.replace("@(polygon)", privateFns.addPolygonStringToLink());
						}
						$("#dyplenke-bottom-ct").append(global.addLinkDiv({
							innerHTML: lenke.innerHTML,
							external: true,
							target: currentUrl
						}));
					});
				}
			}
		});
	},
	newWfsFormat: function (typeName) {
		return new WFS({
			featureNS: "http://mapserver.gis.umn.edu/mapserver",
			featureType: typeName
		});
	},
	readWfsFeatures: function (format, response) {
		return format.readFeatures(response, {
			dataProjection: "EPSG:32632",
			featureProjection: "EPSG:32632"
		});
	},
	renderEiendomsInfo: function (obj, intranett) {
		var target = $("#eiendom-info-ct");
		target.empty();
		target.append(creator.createDiv({
			id: "info-ct-header",
			css: "info-ct-header",
			text: obj.gnr + "/" + obj.bnr + " <span>(gårds-/bruksnr)</span>"
		}));
		target.append(creator.createDiv({
			text: "Bydel: " + global.camelize(obj.bydel, obj.bydel.indexOf(" ") > 0)
		}));
		if(obj.poststed){				
			target.append(creator.createDiv({
				text: global.camelize(obj.poststed, true)
			}));			
		}
		target.append(creator.createDiv({
			css: "redText",
			text: obj.teiger
		}));
		target.append(privateFns.addLinkDiv({
			gnr: obj.gnr, 
			bnr: obj.bnr,
			innerHTML: "Må jeg søke?",
			external: true,
			title: "Åpner tjenesten \"Må du søke om solcelle- eller solfangeranlegg?\"",
			target: "https://skjema-qa.oslo.systems/ekstern/veiledere/datadrevet/#/?id=538&eiendom=" + obj.gnr + "/" + obj.bnr
		}));
		target.append(global.addLinkDiv({
			innerHTML: "Hva gjelder for eiendommen?",
			external: true,
			title: "Åpner tjenesten \"Hva gjelder for eiendommen\"",
			target: "https://tjenester.oslo.kommune.no/ekstern/veiledere/eiendomsinfo/#/?id=538&knr=301&gnr=" + obj.gnr + "&bnr="+ obj.bnr +"&fnr=0&snr=0"
		}));
	},
	addLinkDiv: function (params) {
		var div, span;
		div = creator.createDiv({css: "link-div"});
		//div.className = "click-area link-div";
		span = creator.createSpan({css: "looklike-btn-link", text: params.innerHTML});
		if (params.external) {
			span.innerHTML += " <i class='icon-new-window'></i>";
		}
		if (params.title) {
			span.title = params.title;
		}
		div.appendChild(span);
		div.onclick = function (e) {
			//let info = {};
			//info.sokEiendom = {};
			//info.sokEiendom.data = {gardsnr: params.gnr, bruksnr: params.bnr}
			//window.localStorage.setItem("henvendelse:999", JSON.stringify(info));
			window.open(params.target, params.opens ? params.opens : "_blank");
			e.stopPropagation();
		};

		return div;
	},
	createColumn: function(text, id){
		var col;
		col = creator.createTd({text: text, id: id, css: 'context'});
		col.style.padding = '5px';
		col.style.textAlign = "left";
		return col;
	},
	createTable: function(){
		var table, row, col, heading;
		
		table = creator.createTable({id: "table"});
		table.frame = 'void';
	
		row = creator.createTr({});
		row.appendChild(privateFns.createColumn("Areal(m²)".bold(),""));
		row.appendChild(privateFns.createColumn("Årlig innstråling (kWh/m²)".bold(),""));
		row.appendChild(privateFns.createColumn("Id".bold(),""));
		table.appendChild(row);
		col = creator.createTd({});
	
		heading = privateFns.createHeading("veldigBra");
	
		col.appendChild(heading);
		
		return table;
	},
	createHeading: function(id){
		var heading, headingBtn;
	
		heading = creator.createDiv({css: 'feature-info-heading'});
		headingBtn = creator.createButton({css: 'btn btn-invisible info-heading', id: id});
		headingBtn.onclick = function(){
			$('.'+id).toggle();
			$('#alleFlater'+id).toggle();
			if(id === "veldigBra"){
				if(document.getElementById("solVB").innerHTML == ""){
				}else{
					document.getElementById("solVB").innerHTML = "";
					document.getElementById("arealVB").innerHTML = "";
				}
			}
		};
		heading.appendChild(headingBtn);
		return heading;
	},
}

export default {
	initiate: function (conf) {
		global.handleMapClick = privateFns.contextMenuInteractionHandler;
		config = conf;
		var featureInfo = creator.createAside({
			css: "featureinfo",
		});
		let highlightLayer = new Vector({
			title: 'Highlightlayer',
			layerId: 'highlighter',
			group: 'hidden',
			source: new VectorSource({features: []}),
			opacity: 0.9,
			style: new Style({
				fill: new Fill({
					color: 'rgba(232, 184, 242, 0.3)'
				}),
				stroke: new Stroke({
					color: '#e8b8f2',
					width: 4
				})
			})
		});
		global.map.addLayer(highlightLayer);
		let hoverHighlightLayer = new Vector({
			title: 'hoverHighlightLayer',
			layerId: 'hoverHighlightLayer',
			group: 'hidden',
			source: new VectorSource({features: []}),
			opacity: 0.9,
			style: new Style({
				fill: new Fill({
					color: 'rgba(0, 255, 0, 0.3)'
				}),
				stroke: new Stroke({
					color: '#00ff00',
					width: 4
				})
			})
		});
		global.map.addLayer(hoverHighlightLayer);
		featureInfo.style.width = "470px";
		featureInfo.setAttribute("tabIndex", -1);
		featureInfo.appendChild(privateFns.addFeatureInfoTopDiv());
		featureInfo.appendChild(privateFns.addEiendomFeatureInfo(
			conf.contextMenu.mode.bottom,
			conf.contextMenu.fields
		));
		
		$("#header").after(creator.createDiv({
		})).after(featureInfo);
		privateFns.initContextMenuInteraction(conf);

		featureInfo.setAttribute("aria-hidden", "true");
		$(featureInfo).hide();
	},
};